module.exports = __webpack_public_path__ + "static/media/feature-fire.75e89fd3.svg";